import dayjs from '~/utils/dayjs'

export default function date(date, format = 'DD.MMMM YYYY') {
  return date ? dayjs(date).format(format) : '–'
}
